module.exports = __webpack_public_path__ + "src/assets/img/logo-car-mobicar.d98a7179.svg";